import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../../utils/global_const";
import { ProductContext } from "../../context/ProductContext";
import Header from "../../layouts/header/Header";
import NewArrivalsMain from "../../layouts/main/product/NewArrivalsMain";

const SEOConfig = {
  en: {
    title: "New Nicotine Pouches – Fresh Arrivals | SnusCo",
    description:
      "Be the first to try the latest nicotine pouches! Discover new flavors, strengths, and brands – delivered from Austria to your doorstep anywhere in Europe.",
    keywords:
      "new nicotine pouches, latest snus, new arrivals, buy nicotine pouches, new snus flavors, SnusCo Europe",
    url: "https://www.snusco.eu/en/new-arrivals",
    images: ["https://www.snusco.eu/assets/new-arrivals-category-image.jpg"],
  },
  de: {
    title: "Neuheiten – Neue Nikotinbeutel entdecken | SnusCo",
    description:
      "Bleiben Sie auf dem Laufenden mit unseren neuesten Nikotinbeuteln! Frische Sorten, neue Marken und spannende Aromen – direkt aus Österreich, europaweit geliefert.",
    keywords:
      "neue Nikotinbeutel, Snus Neuheiten, neue Snus Sorten, Nikotinsäcke kaufen, SnusCo Neuheiten",
    url: "https://www.snusco.eu/de/neuheiten",
    images: ["https://www.snusco.eu/assets/new-arrivals-category-image.jpg"],
  },
};

const NewArrivals = () => {
  const { t, i18n } = useTranslation();
  const { loadNewArrivalsBackend, products } = useContext(ProductContext);

  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    if (!initialLoad) {
      // Proverava da li je ovo prvi put da se učitava
      loadNewArrivalsBackend();
      setInitialLoad(true); // Postavlja da je inicijalno učitavanje završeno
    }
  }, [initialLoad]);

  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <NewArrivalsMain />
      <Footer />
    </div>
  );
};

export default NewArrivals;
